/*健康管理*/
const HealthManage = r =>require.ensure([], () => r(require('./')), 'HealthManage')
/*成员列表*/
const MemberList = r =>require.ensure([], () => r(require('./member-list')), 'MemberList')
/*成员新增编辑*/
const MemberAddEdit = r =>require.ensure([], () => r(require('./member-add-edt')), 'MemberAddEdit')
/*组织邀请注册*/
const InviteRegister = r =>require.ensure([], () => r(require('./invite-register')), 'InviteRegister')
/*组织邀请加入*/
const InviteJoin = r =>require.ensure([], () => r(require('./invite-join')), 'InviteJoin')
/*组织邀请接受成功*/
const InviteFinish = r =>require.ensure([], () => r(require('./invite-finish')), 'InviteFinish')
/*支付*/
const paymentChoice = r =>require.ensure([], () => r(require('./payment/payWait')), 'paymentChoice')
//确认是否支付
const TradePayConfirm = r =>require.ensure([], () => r(require('./payment/payConfirm')), 'TradePayConfirm')
//支付完成
const TradePayDone = r =>require.ensure([], () => r(require('./payment/payDone')), 'TradePayDone')
/*订单列表*/
const orderList = r =>require.ensure([], () => r(require('./order/list')), 'orderList')
/*订单详情*/
const orderDetail = r =>require.ensure([], () => r(require('./order/detail')), 'orderDetail')

export default {
  path:'/health-manage',
  component: HealthManage,
  meta: { title: '选择成员' },
  redirect: '/user/login',
  children: [
    {
      path:'member-list',
      component: MemberList,
      meta: { title: '选择成员' }
    },
    {
      path:'member-detail/:id',
      component: MemberAddEdit,
      meta: { title: '详情' }
    },
    {
      path:'invite-register',
      component: InviteRegister,
      meta: { title: '注册' }
    },
    {
      path:'invite-join',
      component: InviteJoin,
      meta: { title: '邀请' }
    },
    {
      path:'invite-finish',
      component: InviteFinish,
      meta: { title: '接受成功' }
    },
    {
      path:'payment-choice',
      component: paymentChoice,
      meta: { title: '立即支付' }
    },
    {
      path: 'payConfirm',
      name: 'TradePayConfirm',
      meta: { title: '支付订单' },
      component: TradePayConfirm
    },
    {
      path: 'payDone',
      name: 'TradePayDone',
      meta: { title: '支付完成' },
      component: TradePayDone
    },
    {
      path:'order-list',
      component: orderList,
      meta: { title: '服务订单' }
    },
    {
      path:'order-detail/:oid',
      component: orderDetail,
      meta: { title: '订单详情' }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/health-manage/router.js